/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Field_Full_NameInputs */

const en_clients_field_full_name = /** @type {(inputs: Clients_Field_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full name`)
};

const pt_br2_clients_field_full_name = /** @type {(inputs: Clients_Field_Full_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nome completo`)
};

/**
* | output |
* | --- |
* | "Full name" |
*
* @param {Clients_Field_Full_NameInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_field_full_name = /** @type {((inputs?: Clients_Field_Full_NameInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Field_Full_NameInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_field_full_name(inputs)
	return pt_br2_clients_field_full_name(inputs)
});